// Models
import { updateTxnStatus } from '../../../utils/helperMethods';
import TransactionList from '../models/transactionList';
import TransactionStatusData from '../models/transactionStatusData';

import {
    FETCH_TRANSACTIONS_REQUEST,
    FETCH_TRANSACTIONS_SUCCESS,
    FETCH_TRANSACTIONS_ERROR,
    HIDE_TRANSACTION_LOADER,
    SHOW_TRANSACTION_LOADER,
    GENERATE_REPORT_REQUEST,
    GENERATE_REPORT_SUCCESS,
    GENERATE_REPORT_ERROR,
    GET_ACTIVE_REPORT_SUCCESS,
    GET_ACTIVE_REPORT_ERROR,
    DOWNLOAD_REPORT_SUCCESS,
    DOWNLOAD_REPORT_ERROR,
    FETCH_TRANSACTIONS_STATUS_SUCCESS,
    FETCH_TRANSACTIONS_STATUS_ERROR,
    RESET_TRANSACTION_STATE,
    GET_REFUND_TXN_SUCCESS,
    RESET_REFUND_TXN,
} from './transactions.constants';

const initialState = {
    tableData: [],
    pagination: {},
    error: {},
    statusData: {
        details: {},
        error: {},
    },
    refundTxnData: {
        details: [],
        error: {},
    },
    generatedFile: {
        isSuccess: false,
        error: {},
    },
    activeReports: {
        reports: {},
        error: {},
    },
    downloadReport: {},
    isLoading: false,
};

const getActiveReports = reports => {
    const reportsAll = {};
    if (reports.reportsList.length) {
        reportsAll.generating = reports.reportsList.filter(
            item => item.requestStatus !== 'COMPLETED'
        );
        reportsAll.complete = reports.reportsList.filter(
            item => item.requestStatus === 'COMPLETED'
        );
    }
    return reportsAll;
};

export const transactionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TRANSACTIONS_SUCCESS: {
            const createTransactionData = new TransactionList(action.payload);
            return {
                ...state,
                ...createTransactionData,
                error: {},
            };
        }
        case FETCH_TRANSACTIONS_REQUEST:
            return {
                ...state,
                error: {},
            };
        case FETCH_TRANSACTIONS_ERROR:
            return {
                ...state,
                ...action.payload,
            };
        case FETCH_TRANSACTIONS_STATUS_SUCCESS:
            const viewTransactionData = new TransactionStatusData(
                action.payload
            );

            const updatedTableData = updateTxnStatus(
                state.tableData,
                viewTransactionData
            );

            return {
                ...state,
                statusData: { ...viewTransactionData },
                tableData: updatedTableData,
            };
        case FETCH_TRANSACTIONS_STATUS_ERROR:
            return {
                ...state,
                statusData: { details: {}, error: { ...action.payload } },
            };
        case GENERATE_REPORT_REQUEST:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };
        case GENERATE_REPORT_SUCCESS:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: true },
            };
        case GENERATE_REPORT_ERROR:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };
        case GET_ACTIVE_REPORT_SUCCESS:
            return {
                ...state,
                activeReports: { reports: getActiveReports(action.payload) },
            };
        case GET_ACTIVE_REPORT_ERROR:
            return {
                ...state,
                activeReports: { ...action.payload },
            };
        case RESET_REFUND_TXN:
            return {
                ...state,
                refundTxnData: initialState.refundTxnData,
            };
        case DOWNLOAD_REPORT_SUCCESS:
            return {
                ...state,
                downloadReport: { fileUrl: { ...action.payload } },
            };
        case DOWNLOAD_REPORT_ERROR:
            return {
                ...state,
                downloadReport: { ...action.payload },
            };
        case GET_REFUND_TXN_SUCCESS:
            return {
                ...state,
                refundTxnData: {
                    details: [...action.payload.refundViewResponseList],
                    error: {},
                },
            };
        case SHOW_TRANSACTION_LOADER:
            return { ...state, isLoading: true };
        case HIDE_TRANSACTION_LOADER:
            return { ...state, isLoading: false };
        case RESET_TRANSACTION_STATE:
            return initialState;
        default:
            return state;
    }
};
